/* MTD Look Inside preview — page stepper with arrows, dots and keyboard. */
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.mtdReady === 'true') return;
    root.dataset.mtdReady = 'true';

    var pages = Array.prototype.slice.call(root.querySelectorAll('[data-mtd-page]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-mtd-page-dot]'));
    var prev = root.querySelector('[data-mtd-page-prev]');
    var next = root.querySelector('[data-mtd-page-next]');
    if (pages.length < 2) return;

    var index = 0;

    function show(i) {
      // Wrap around, so the arrows never dead-end.
      index = (i + pages.length) % pages.length;
      pages.forEach(function (p, n) { p.classList.toggle('is-active', n === index); });
      dots.forEach(function (d, n) {
        d.classList.toggle('is-active', n === index);
        if (n === index) d.setAttribute('aria-selected', 'true');
        else d.removeAttribute('aria-selected');
      });
    }

    if (prev) prev.addEventListener('click', function () { show(index - 1); });
    if (next) next.addEventListener('click', function () { show(index + 1); });
    dots.forEach(function (d, n) {
      d.addEventListener('click', function () { show(n); });
    });

    // Arrow keys work once something inside has focus.
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { show(index - 1); }
      if (e.key === 'ArrowRight') { show(index + 1); }
    });
  }

  function boot() { document.querySelectorAll('[data-mtd-preview]').forEach(init); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else { boot(); }

  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-mtd-preview]').forEach(init);
  });
})();
